import { gql } from '@apollo/client';

export interface ProductUpdate {
  id: string;
  title: string;
  description: string;
  category: string | null;
  publishedAt: string;
}

export interface ProductUpdatesData {
  productUpdates: ProductUpdate[];
}

export interface ProductUpdatesVariables {
  fromDate: string;
  throughDate: string;
}

export const GET_PRODUCT_UPDATES = gql`
  query HomeProductUpdates(
    $fromDate: timestamptz!
    $throughDate: timestamptz!
  ) {
    productUpdates(
      where: { publishedAt: { _gte: $fromDate, _lte: $throughDate } }
      order_by: [{ publishedAt: desc }, { id: asc }]
      limit: 100
    ) {
      id
      title
      description
      category
      publishedAt
    }
  }
`;
